var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon10({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 25.1877C56.7055 25.1877 55.6562 24.1384 55.6562 22.8439V4.09393C55.6562 2.79947 56.7055 1.75018 58 1.75018C59.2942 1.75018 60.3438 2.79947 60.3438 4.09393V22.8439C60.3438 24.1384 59.2942 25.1877 58 25.1877Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 114.25C56.7055 114.25 55.6562 113.201 55.6562 111.906V93.1564C55.6562 91.8622 56.7055 90.8127 58 90.8127C59.2942 90.8127 60.3438 91.8622 60.3438 93.1564V111.906C60.3438 113.201 59.2942 114.25 58 114.25Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8603 35.4838C82.2603 35.4838 81.6608 35.255 81.203 34.7973C80.2878 33.8821 80.2878 32.398 81.203 31.4828L94.4593 18.2265C95.3747 17.3113 96.8583 17.311 97.774 18.2265C98.6893 19.1417 98.6893 20.6258 97.774 21.541L84.5178 34.7973C84.0598 35.255 83.4603 35.4838 82.8603 35.4838Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8837 98.4603C19.2837 98.4603 18.6842 98.2313 18.2265 97.7738C17.3112 96.8586 17.3112 95.3746 18.2265 94.4591L31.4827 81.2028C32.3979 80.2878 33.8818 80.2881 34.7972 81.2028C35.7125 82.1181 35.7125 83.6021 34.7972 84.5176L21.541 97.7738C21.0835 98.2313 20.4835 98.4603 19.8837 98.4603Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.906 60.3439H93.1562C91.862 60.3439 90.8125 59.2944 90.8125 58.0002C90.8125 56.7057 91.862 55.6564 93.1562 55.6564H111.906C113.2 55.6564 114.25 56.7057 114.25 58.0002C114.25 59.2944 113.2 60.3439 111.906 60.3439Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8438 60.3439H4.09375C2.7993 60.3439 1.75 59.2944 1.75 58.0002C1.75 56.7057 2.7993 55.6564 4.09375 55.6564H22.8438C24.1382 55.6564 25.1875 56.7057 25.1875 58.0002C25.1875 59.2944 24.1382 60.3439 22.8438 60.3439Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1165 98.4603C95.5165 98.4603 94.917 98.2313 94.4593 97.7738L81.203 84.5176C80.2878 83.6024 80.2878 82.1183 81.203 81.2028C82.1185 80.2878 83.6021 80.2878 84.5178 81.2028L97.774 94.4591C98.6893 95.3743 98.6893 96.8584 97.774 97.7738C97.3161 98.2313 96.7163 98.4603 96.1165 98.4603Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.14 35.4838C32.5402 35.4838 31.9402 35.255 31.4827 34.7973L18.2265 21.541C17.3112 20.6258 17.3112 19.1417 18.2265 18.2263C19.1417 17.3108 20.6258 17.311 21.5412 18.2263L34.7975 31.4825C35.7127 32.3978 35.7127 33.8818 34.7975 34.7973C34.3397 35.255 33.7397 35.4838 33.14 35.4838Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22.8439C38.5844 22.8439 22.8438 38.5846 22.8438 58.0002C22.8438 77.4158 38.5844 93.1564 58 93.1564C77.4156 93.1564 93.1562 77.4158 93.1562 58.0002C93.1562 38.5846 77.4156 22.8439 58 22.8439Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0625 67.3752V76.7502H43.9375V67.3752C43.9375 59.608 50.2328 53.3127 58 53.3127C61.8836 53.3127 65.3992 54.8877 67.9445 57.4306C70.4875 59.976 72.0625 63.4916 72.0625 67.3752Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M58 53.3127C63.1777 53.3127 67.375 49.1153 67.375 43.9377C67.375 38.76 63.1777 34.5627 58 34.5627C52.8223 34.5627 48.625 38.76 48.625 43.9377C48.625 49.1153 52.8223 53.3127 58 53.3127Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.75 53.3127H81.4375V58.0002H76.75V53.3127Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5625 53.3127H39.25V58.0002H34.5625V53.3127Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6873 11.1252C62.0873 11.1252 61.4877 10.8964 61.03 10.4387L57.9998 7.40846L54.9695 10.4387C54.0543 11.3539 52.5702 11.3539 51.6548 10.4387C50.7393 9.52346 50.7395 8.03939 51.6548 7.12393L56.3423 2.43643C57.2577 1.52119 58.7416 1.52119 59.657 2.43643L64.3445 7.12393C65.2598 8.03916 65.2598 9.52322 64.3445 10.4387C63.8868 10.8964 63.2873 11.1252 62.6873 11.1252Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9999 114.25C57.4002 114.25 56.8002 114.021 56.3427 113.564L51.6552 108.876C50.7399 107.961 50.7399 106.477 51.6552 105.561C52.5704 104.646 54.0545 104.646 54.9699 105.561L57.9999 108.592L61.0302 105.561C61.9456 104.646 63.4292 104.646 64.3449 105.561C65.2602 106.477 65.2602 107.961 64.3449 108.876L59.6574 113.564C59.1995 114.021 58.5999 114.25 57.9999 114.25Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1164 28.8556C94.8222 28.8556 93.7727 27.8063 93.7727 26.5119V22.2275H89.4883C88.1941 22.2275 87.1445 21.1782 87.1445 19.8838C87.1445 18.5893 88.1941 17.54 89.4883 17.54H96.1164C97.4106 17.54 98.4602 18.5893 98.4602 19.8838V26.5119C98.4602 27.8063 97.4106 28.8556 96.1164 28.8556Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5119 98.4603H19.8838C18.5893 98.4603 17.54 97.4108 17.54 96.1166V89.4885C17.54 88.1942 18.5893 87.1447 19.8838 87.1447C21.1782 87.1447 22.2275 88.1942 22.2275 89.4885V93.7728H26.5119C27.8064 93.7728 28.8557 94.8224 28.8557 96.1166C28.8557 97.4108 27.8064 98.4603 26.5119 98.4603Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107.219 65.0314C106.619 65.0314 106.019 64.8024 105.562 64.3449C104.646 63.4297 104.646 61.9456 105.562 61.0302L108.592 58.0002L105.561 54.9699C104.646 54.0547 104.646 52.5706 105.561 51.6552C106.477 50.7399 107.96 50.7399 108.876 51.6552L113.564 56.3427C114.479 57.2579 114.479 58.742 113.564 59.6574L108.876 64.3449C108.418 64.8024 107.819 65.0314 107.219 65.0314Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78119 65.0314C8.18143 65.0314 7.58143 64.8024 7.12393 64.3449L2.43643 59.6574C1.52119 58.7422 1.52119 57.2581 2.43643 56.3427L7.12393 51.6552C8.03916 50.7399 9.52322 50.7399 10.4387 51.6552C11.3542 52.5704 11.3539 54.0545 10.4387 54.9699L7.40822 58.0002L10.4385 61.0304C11.3537 61.9456 11.3537 63.4297 10.4385 64.3452C9.98096 64.8024 9.38096 65.0314 8.78119 65.0314Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1164 98.4603H89.4883C88.1941 98.4603 87.1445 97.4108 87.1445 96.1166C87.1445 94.8224 88.1941 93.7728 89.4883 93.7728H93.7727V89.4885C93.7727 88.1942 94.8222 87.1447 96.1164 87.1447C97.4106 87.1447 98.4602 88.1942 98.4602 89.4885V96.1166C98.4602 97.4108 97.4106 98.4603 96.1164 98.4603Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8838 28.8556C18.5893 28.8556 17.54 27.8063 17.54 26.5119V19.8838C17.54 18.5893 18.5893 17.54 19.8838 17.54H26.5119C27.8064 17.54 28.8557 18.5893 28.8557 19.8838C28.8557 21.1782 27.8064 22.2275 26.5119 22.2275H22.2275V26.5119C22.2275 27.8063 21.1782 28.8556 19.8838 28.8556Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon10);
export default __webpack_public_path__ + "static/media/icon-10.fa32953ca2224c8d1f52b86dc29f9e21.svg";
export { ForwardRef as ReactComponent };